export default __webpack_public_path__ + "static/media/1896.cd69f6e5.png";